import IframeBridge from 'IframeBridge';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { findImage } from 'utils/Utils';

const CancelPage = () => {
  const { t, i18n } = useTranslation();

  const { paymentState } = usePaymentState();
  const returnType = window.sessionStorage.getItem('returnType');

  useEffect(() => {
    if (returnType === 'DIRECT') {
      closeProcess();
    }
  }, [returnType]);

  const closeProcess = () => {
    const PayConfig = paymentState;
    const returnObject = {
      resultStatus: 'FAIL',
      resultCode: paymentState.resultCode,
      resultMessage: paymentState.resultMessage,
      tid: paymentState.tid,
      orderId: paymentState.orderId,
      mallReserved: paymentState.mallReserved,
      returnUrl: paymentState.returnUrl,
    };

    if (isMobile) {
      const url = new URL(PayConfig.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('status', 'FAIL');
      params.set('displayAmount', PayConfig?.requestAmount.toString());
      params.set('displayCurrency', PayConfig?.requestCurrency);
      params.set('orderId', PayConfig?.orderId);
      params.set('productName', PayConfig?.productName);

      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  const handleAllClose = e => {
    e.preventDefault();
    closeProcess();
  };

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('cancel.png')} />
          </div>
          <div className="title">{t('payment_cancel')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('payment_cancel_completed')}
          </div>
          <div className="info-box">
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('total_amount')}</div>
              <div>
                {Number(paymentState.requestAmount).toLocaleString('en-US')}
              </div>
            </div>
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('order_number')}</div>
              <div>{paymentState.orderId}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="completed-btn">
        <div className="box confirmBox">
          <button className="all-close" onClick={handleAllClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </>
  );
};

export default CancelPage;
